module.exports = __webpack_public_path__ + "img/redwood-bar-10.25.24.b10f8c99.png";